import { render, staticRenderFns } from "./marketingData.vue?vue&type=template&id=2a5589c9&scoped=true&"
import script from "./marketingData.vue?vue&type=script&lang=js&"
export * from "./marketingData.vue?vue&type=script&lang=js&"
import style0 from "./marketingData.vue?vue&type=style&index=0&id=2a5589c9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5589c9",
  null
  
)

export default component.exports